import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { RouterLink, ActivatedRoute } from '@angular/router';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import {
  DriverPetition,
  DriverPetitionComponent,
} from 'src/app/shared/components/vacations/driver-petition/driver-petition.component';
import { VacationSwitchComponent } from 'src/app/shared/components/vacations/vacation-switch/vacation-switch.component';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { HolidaysService } from 'src/app/shared/services/holidays/holidays.service';
import { DriverProfileResponse } from 'src/app/shared/interfaces/holidays.interface';
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';

@Component({
  selector: 'app-driver-profile',
  imports: [
    LoaderComponent,
    MatIconModule,
    RouterLink,
    MatButtonModule,
    MatSlideToggleModule,
    MatTabGroup,
    MatTab,
    VacationSwitchComponent,
    DriverPetitionComponent,
    CalendarComponent,
    MatDivider,
  ],
  templateUrl: './driver-profile.component.html',
  styleUrls: [
    './driver-profile.component.css',
    '../../../shared/styles/layout.css',
  ],
})
export class DriverProfileComponent implements OnInit {
  driverProfile: DriverProfileResponse | null = null;
  petitions: DriverPetition[] = [];

  constructor(
    private loaderService: LoaderService,
    private route: ActivatedRoute,
    private holidaysService: HolidaysService
  ) {}

  ngOnInit(): void {
    const driverId = this.route.snapshot.params['driverId'];
    if (driverId) {
      this.loadDriverProfile(Number(driverId));
    }
  }

  loadDriverProfile(driverId: number): void {
    this.loaderService.showLoader();
    this.holidaysService.getDriverProfile(driverId, true).subscribe({
      next: (data) => {
        this.loaderService.hideLoader();
        this.driverProfile = data;

        // Convert pending_requests to DriverPetition format for the component
        this.petitions = data.pending_requests.map((request) => ({
          id: request.id,
          startDate: request.start_date,
          endDate: request.end_date,
          days: request.duration_days,
          personal: request.request_type === 'personal_day',
        }));

        console.log('Driver profile data:', this.driverProfile);
      },
      error: (error) => {
        this.loaderService.hideLoader();
        console.error('Error fetching driver profile:', error);
      },
    });
  }

  get isLoading(): boolean {
    return this.loaderService.getLoader();
  }
}
